<!-- Error page-->
<div class="misc-wrapper">
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <div>
        <img class="mb-2" src="{{ court_logo_path }}" alt="Not authorized page" height="150" />
      </div>
      <h2 class="mb-1 text-dark">Under Maintenance 🛠</h2>
      <p class="mb-2">We're currently undergoing essential maintenance to bring you an even better online experience. We
        apologize for any inconvenience this may cause and appreciate your patience.</p>
      <!-- <a class="btn btn-primary mb-2 btn-sm-block" (click)="goBack()" rippleEffect>Back to home</a> -->
      <!-- <img
        class="img-fluid"
        [src]="
          coreConfig.layout.skin === 'dark'
            ? 'assets/images/pages/error-dark.svg'
            : 'assets/images/pages/error.svg'
        "
        alt="Error page"
      /> -->
    </div>
  </div>
</div>
<!-- / Error page-->